export const sliderItems = [
  {
    id: 0,
    img: "https://i.ibb.co/9344jv4/3.png",
    title: "SUMMER SALE!",
    desc: "Heat up your savings with our scorching summer sale! Dive into cool discounts on everything you need for a sizzling season of fun under the sun.",
    bg: "f9e9e9",
  },
  {
    id: 1,
    img: "https://i.ibb.co/QHjGfdX/2.png",
    title: "WINTER SALE!",
    desc: "Embrace the chill with hot deals! Find your winter essentials at irresistible prices, ensuring you stay cozy and stylish throughout the season.",
    bg: "dcf5f9",
  },
  {
    id: 2,
    img: "https://i.ibb.co/MkfHnxN/young-boy-going-for-world-tour.png",
    title: "POPOULAR SALE!",
    desc: "Join the trendsetters! Explore our popular sale featuring must-have items loved by everyone. Grab these favorites at amazing prices before they're gone! ",
    bg: "ebe1fc",
  },
  {
    id: 3,
    img: "https://i.ibb.co/JkNGLbG/diwali-celebration.png",
    title: "DIWALI SALE!",
    desc: "Illuminate your festivities with our Diwali Sale! Discover a treasure trove of discounts and celebrate the festival of lights with joy, prosperity, and incredible savings on top-notch products.",
    bg: "A0E7E5",
  },
];
export const categories = [
  {
    id: 1,
    img: "https://images.pexels.com/photos/5886041/pexels-photo-5886041.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "SHIRT STYLE!",
    cat: "shirts",
  },
  {
    id: 2,
    img: "https://images.pexels.com/photos/2983464/pexels-photo-2983464.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "LOUNGEWEAR LOVE",
    cat: "loungewear",
  },
  {
    id: 3,
    img: "https://images.pexels.com/photos/5480696/pexels-photo-5480696.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    title: "LIGHT JACKETS",
    cat: "personal",
  },
  {
    id: 4,
    img: "https://img.freepik.com/free-photo/close-up-photo-young-successful-business-man-black-suit_171337-9509.jpg?w=1060&t=st=1704165372~exp=1704165972~hmac=d0a9721e7cc94892ec0471e334c80b16467b64febba7a3ae1b0499ddae4d1e81",
    title: "Black Suits",
    cat: "suit",
  },
  {
    id: 5,
    img: "https://img.freepik.com/free-photo/portrait-indian-woman-with-flag_23-2150913220.jpg?t=st=1704164649~exp=1704168249~hmac=c3bafbb9c46e50723898628198b9ad5d8a64f68def3d463a5702005990d739a9&w=740",
    title: "Saree",
    cat: "saree",
  },
  {
    id: 6,
    img: "https://img.freepik.com/free-photo/full-length-portrait-cute-little-girl-hat_171337-13768.jpg?w=360&t=st=1704165488~exp=1704166088~hmac=c0b77a32a03f3c289d9b209715c2dd714b0e07eca641f7de3a998366cc9695ff",
    title: "Kids",
    cat: "kids",
  },
];

export const popularProducts = [
  {
    id: 1,
    img: "https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png",
  },
  {
    id: 2,
    img: "https://rukminim1.flixcart.com/image/832/832/l1nwnm80/dress/2/e/d/3xl-p-dmk2210-w-juneberry-original-imagd6ceg4gcnyvg.jpeg?q=70",
  },
  {
    id: 3,
    img: "https://www.prada.com/content/dam/pradanux_products/U/UCS/UCS319/1YOTF010O/UCS319_1YOT_F010O_S_182_SLF.png",
  },
  {
    id: 4,
    img: "https://rukminim1.flixcart.com/image/832/832/l0pm3680/t-shirt/c/u/z/s-2115-the-dry-state-original-imagcfz6jz2pz53m.jpeg?q=70",
  },
  {
    id: 5,
    img: "https://images.ctfassets.net/5gvckmvm9289/3BlDoZxSSjqAvv1jBJP7TH/65f9a95484117730ace42abf64e89572/Noissue-x-Creatsy-Tote-Bag-Mockup-Bundle-_4_-2.png",
  },
  {
    id: 6,
    img: "https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
  },
  {
    id: 7,
    img: "https://rukminim1.flixcart.com/image/832/832/xif0q/sari/h/h/u/free-rani-gulab-harlik-pasto-original-imafnvwbfgkp4hd4-bb.jpeg?q=70",
  },
  {
    id: 8,
    img: "https://www.pngarts.com/files/3/Women-Jacket-PNG-High-Quality-Image.png",
  },
  {
    id: 9,
    img: "https://images.ctfassets.net/5gvckmvm9289/3BlDoZxSSjqAvv1jBJP7TH/65f9a95484117730ace42abf64e89572/Noissue-x-Creatsy-Tote-Bag-Mockup-Bundle-_4_-2.png",
  },
  {
    id: 10,
    img: "https://rukminim1.flixcart.com/image/832/832/l1nwnm80/dress/2/e/d/3xl-p-dmk2210-w-juneberry-original-imagd6ceg4gcnyvg.jpeg?q=70",
  },
  {
    id: 11,
    img: "https://d3o2e4jr3mxnm3.cloudfront.net/Rocket-Vintage-Chill-Cap_66374_1_lg.png",
  },
  {
    id: 12,
    img: "https://rukminim1.flixcart.com/image/832/832/xif0q/sari/h/h/u/free-rani-gulab-harlik-pasto-original-imafnvwbfgkp4hd4-bb.jpeg?q=70",
  },
];
